import { AxiosResponse } from 'axios'
import { RequestCDU, RequestREAD } from 'services/Instances'

export const SyndicateServices = () => {
  const path = 'Sindicato'

  const create = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

  const del = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/Delete?id=${id}`)

  const getAll = async (): Promise<AxiosResponse<ISindicato[]>> =>
    await RequestREAD.get(path)

  const get = async (id: number): Promise<AxiosResponse<ISindicato>> =>
    await RequestREAD.get(`${path}/${id}`)

  /*
  const get = async (id: number): Promise<AxiosResponse<ISindicato>> =>
    await RequestREAD.get(`${path}/AnexosXSindicato`,{
      headers: {id: id},
    })
    */

  const getFiltro = async (
    requestObj?: ISindicatoFiltro
  ): Promise<AxiosResponse<IGetFiltroResponse[]>> =>
    await RequestREAD.post(`${path}/Filtro`, requestObj)

  const patch = async (requestObj: ISindicato): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/Update`, requestObj)

  const anexarDocumento = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/AnexarDocumentoSindicato`, requestObj)

  const deleteDocumento = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/DeleteAnexarDocumentoSindicato`, {
      headers: { id: id }
    })

  return {
    anexarDocumento,
    create,
    del,
    deleteDocumento,
    get,
    getAll,
    getFiltro,
    patch
  }
}

export interface IGetFiltroResponse {
  idSindicato: number
  nmSindicato: string
  cdCnpj: string

  // devido inconsistencia no endpoint
  cnpjSindicato?: string
}

export const AttachDocSyndicateServices = () => {
  const path = 'Sindicato/AnexarDocumentoSindicato'
  const create = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}`, requestObj)
  const del = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/Delete?id=${id}`)
  return { create, del }
}

export interface ISindicato {
  idSindicato?: number
  cdCnpj: string
  nmSindicato: string
  cdCep?: string
  txEndereco?: string
  nuNumero?: string
  txComplemento?: string
  nmBairro?: string
  sgPais?: string
  sgEstado?: string
  txCidade?: string
  txObservacao?: string
  txTipo: string
  dtInicVigencia: string
  dtFimVigencia: string
  flAnexado?: string
  anexos?: any[]
}

export interface IAnexarDocumentoSindicato {
  idDocumentoSindcato?: number
  tipoDocumentoSindicato?: string
  sindicatoId?: number
  txDescricao?: string
  dtAnexo?: string
  gedExternalId?: number
  txFilePath?: string
  txFilename?: string
  dtAnoMesCompetencia?: string
  cnpjSindicato?: string
  nmSindicato?: string
  file?: string
}

export interface ISindicatoFiltro {
  cdCnpj?: string
  nmSindicato?: string
  txTipo?: string
}
